import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {gtmEventFormOpen, IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {openLeadModal, setUseAdditionalFormField} from "../state/main_lead_slice";
import {ApplicationModalStep} from "../types/ApplicationModalStep";
import {GTMEventApplicationSourceSection} from "../types/lead/GTMEvenApplicationSourceSection";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";

export interface IApplicationModalButtonRenderProps {
    isOpened: boolean;
    openModal: (gtmProps: {
        clickText: InquiryButtonTypeName | string;
        source: GTMEventApplicationSourceSection | string;
        vendorName: string;
        offerName: string;
    }) => void;
}

type IProps = {
    render: (props: IApplicationModalButtonRenderProps) => ReactNode;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "gtmMeta">;

export const ApplicationModalButton = (props: IProps) => {
    const {render, openOnMount, onOpen, onClose, ...openModalPayload} = props;
    const dispatch = useAppDispatch();
    const {hasPhoneVerified, isOpenPricesVariant} = useShouldHidePrices();

    const isOpened = useAppSelector((state) => state.mainLead.isModalOpen);
    const wasOpenedRef = useRef(false);
    const shouldUseSilentLeadFlow = isOpenPricesVariant && !hasPhoneVerified && openModalPayload.flowVariant !== "promotion";
    const shouldKeepInitialStep = openModalPayload.initialStep === ApplicationModalStep.APPLICATION_FORM_WITH_TOPIC;
    const resolvedOpenModalPayload: Omit<MainLeadDataPayload, "gtmMeta"> = shouldUseSilentLeadFlow
        ? {
              ...openModalPayload,
              flowVariant: "silent_lead",
              initialStep: shouldKeepInitialStep ? openModalPayload.initialStep : ApplicationModalStep.PROMOTION_FORM
          }
        : openModalPayload;

    const handleOpenModal = useCallback(
        (openButtonSource: string, openButtonSourceText: string) => {
            if (resolvedOpenModalPayload.useAdditionalFormField) {
                dispatch(setUseAdditionalFormField(resolvedOpenModalPayload.useAdditionalFormField));
            }

            dispatch(
                openLeadModal({
                    ...resolvedOpenModalPayload,
                    gtmMeta: {
                        openButtonSource,
                        openButtonSourceText
                    }
                })
            );
        },
        [dispatch, resolvedOpenModalPayload]
    );

    const openModal = useCallback(
        (gtmProps?: IGTMEventLeadForm) => {
            if (gtmProps) {
                gtmEventFormOpen(gtmProps.clickText, gtmProps.source, gtmProps.vendorName, gtmProps.offerName);
                handleOpenModal(gtmProps.clickText, gtmProps.source);
            }
        },
        [handleOpenModal]
    );

    useEffect(() => {
        if (openOnMount) {
            openModal();
        }
    }, []);

    useEffect(() => {
        const wasOpened = Boolean(wasOpenedRef.current);
        if (!wasOpened && isOpened) {
            onOpen?.();
        }

        if (wasOpened && !isOpened) {
            onClose?.();
        }

        wasOpenedRef.current = isOpened;
    }, [isOpened]);

    const renderProps = useMemo(() => ({isOpened, openModal}), [isOpened, openModal]);

    return <>{render(renderProps)}</>;
};
import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {gtmEventFormOpen, IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {openLeadModal, setUseAdditionalFormField} from "../state/main_lead_slice";
import {ApplicationModalStep} from "../types/ApplicationModalStep";
import {GTMEventApplicationSourceSection} from "../types/lead/GTMEvenApplicationSourceSection";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";

export interface IApplicationModalButtonRenderProps {
    isOpened: boolean;
    openModal: (gtmProps: {
        clickText: InquiryButtonTypeName | string;
        source: GTMEventApplicationSourceSection | string;
        vendorName: string;
        offerName: string;
    }) => void;
}

type IProps = {
    render: (props: IApplicationModalButtonRenderProps) => ReactNode;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "gtmMeta">;

export const ApplicationModalButton = (props: IProps) => {
    const {render, openOnMount, onOpen, onClose, ...openModalPayload} = props;
    const dispatch = useAppDispatch();
    const {hasPhoneVerified, isOpenPricesVariant} = useShouldHidePrices();

    const isOpened = useAppSelector((state) => state.mainLead.isModalOpen);
    const wasOpenedRef = useRef(false);
    const shouldUseSilentLeadFlow = isOpenPricesVariant && !hasPhoneVerified && openModalPayload.flowVariant !== "promotion";
    const shouldKeepInitialStep = openModalPayload.initialStep === ApplicationModalStep.APPLICATION_FORM_WITH_TOPIC;
    const resolvedOpenModalPayload: Omit<MainLeadDataPayload, "gtmMeta"> = shouldUseSilentLeadFlow
        ? {
              ...openModalPayload,
              flowVariant: "silent_lead",
              initialStep: shouldKeepInitialStep ? openModalPayload.initialStep : ApplicationModalStep.PROMOTION_FORM
          }
        : openModalPayload;

    const handleOpenModal = useCallback(
        (openButtonSource: string, openButtonSourceText: string) => {
            if (resolvedOpenModalPayload.useAdditionalFormField) {
                dispatch(setUseAdditionalFormField(resolvedOpenModalPayload.useAdditionalFormField));
            }

            dispatch(
                openLeadModal({
                    ...resolvedOpenModalPayload,
                    gtmMeta: {
                        openButtonSource,
                        openButtonSourceText
                    }
                })
            );
        },
        [dispatch, resolvedOpenModalPayload]
    );

    const openModal = useCallback(
        (gtmProps?: IGTMEventLeadForm) => {
            if (gtmProps) {
                gtmEventFormOpen(gtmProps.clickText, gtmProps.source, gtmProps.vendorName, gtmProps.offerName);
                handleOpenModal(gtmProps.clickText, gtmProps.source);
            }
        },
        [handleOpenModal]
    );

    useEffect(() => {
        if (openOnMount) {
            openModal();
        }
    }, []);

    useEffect(() => {
        const wasOpened = Boolean(wasOpenedRef.current);
        if (!wasOpened && isOpened) {
            onOpen?.();
        }

        if (wasOpened && !isOpened) {
            onClose?.();
        }

        wasOpenedRef.current = isOpened;
    }, [isOpened]);

    const renderProps = useMemo(() => ({isOpened, openModal}), [isOpened, openModal]);

    return <>{render(renderProps)}</>;
};
